import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { withRouter, WithRouterProps } from 'react-router';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';

import { CompareOtherSellersLinkData } from '../schemas/rql';

interface IExternalProps {
  listing: CompareOtherSellersLinkData.Fragment;
}

type IProps = IExternalProps & IUserContext & WithRouterProps;

const COMPONENT_NAME = 'CompareOtherSellersLink';

export const CompareOtherSellersLinkFragment = gql`
fragment CompareOtherSellersLinkData on Listing {
  _id
  csp {
    _id
    id
    webLink {
      href
    }
  }
}
`;

function qualifyForLink(props: IProps): boolean {
  const { location } = props;
  const rollupParam = location?.query?.rollup;

  return !!rollupParam;
}

export function CompareOtherSellersLink(props: IProps) {
  const clickEvent = {
    eventName: MParticleEventName.ClickedCompareOtherSellersLink,
    componentName: COMPONENT_NAME,
  };

  if (!qualifyForLink(props)) { return null; }

  return (
    <CoreLink
      className="width-100 align-center mt-1"
      to={props.listing.csp.webLink.href}
      clickEvent={clickEvent}
    >
      <div className="button-as-link icon-r-angle-right">
        {I18n.t('discovery.compareOtherSellersLink.linkText')}
      </div>
    </CoreLink>
  );
}

export default withUserContext<IExternalProps>(withRouter(CompareOtherSellersLink));
